import * as React from 'react';
import type { SVGProps } from 'react';
const SvgQuery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M3.044 3.333a.5.5 0 0 0-.5.5v1.538a.5.5 0 0 0 .5.5h.018v8.57c0 .966.784 1.75 1.75 1.75h1.202a.5.5 0 0 0 .5.476H8.05a.5.5 0 0 0 .5-.5v-1.538a.5.5 0 0 0-.5-.5H6.513a.5.5 0 0 0-.5.5v.062h-1.2a.25.25 0 0 1-.25-.25v-3.657h1.45a.5.5 0 0 0 .5.485H8.05a.5.5 0 0 0 .5-.5V9.232a.5.5 0 0 0-.5-.5H6.513a.5.5 0 0 0-.5.5v.052h-1.45V5.871h.018a.5.5 0 0 0 .5-.5V3.833a.5.5 0 0 0-.5-.5zm4.456.519a.75.75 0 0 0 0 1.5h8.443a.75.75 0 0 0 0-1.5zm3.536 5.432a.75.75 0 0 0 0 1.5h4.907a.75.75 0 0 0 0-1.5zm0 5.364a.75.75 0 0 0 0 1.5h4.907a.75.75 0 0 0 0-1.5z" />
  </svg>
);
export default SvgQuery;
